import { defineComponent as _defineComponent } from 'vue';
import { BModal } from "bootstrap-vue";
import { ref } from "vue";
import StatelessTags from "@/components/TagsMultiselect/StatelessTags.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TagsSelectionDialog',
    props: {
        title: { default: "Select tags to add" },
        initialTags: { default: () => [] }
    },
    emits: ["cancel", "ok"],
    setup(__props, { emit }) {
        const props = __props;
        const tags = ref(props.initialTags);
        function onTagsChange(newTags) {
            tags.value = newTags;
        }
        return { __sfc: true, props, tags, emit, onTagsChange, BModal, StatelessTags };
    }
});
